import React, {useMemo} from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import ReactTable from "../../Components/ReactTable";
import {LoadingWrapper} from "../../Components/LoadingWrapper";
import {formattedCell} from "./storeLinkageFormatters";

export const STORE_LINKAGE_SALES_HISTORY_TABLE_TEST_ID = 'store-linkage-sales-history-table';
export const STORE_LINKAGE_SALES_HISTORY_ERROR_TEST_ID = 'store-linkage-sales-history-error';
export const STORE_LINKAGE_SALES_HISTORY_WINNER_TEST_ID = 'linkage-sales-history-winner-badge';

const SALES_HISTORY_COLUMNS = [
    {
        accessorKey: "source",
        header: "SOURCE",
        size: 250,
        cell: ({row}) => <>
            {row.original.source}
            {row.original.isWinner &&
                <span className={"linkage-winner-badge"} data-testid={STORE_LINKAGE_SALES_HISTORY_WINNER_TEST_ID}>WINNER</span>}
        </>
    },
    {accessorKey: "sourceStoreId", header: "STORE ID", size: 200, cell: formattedCell},
    {accessorKey: "weeksOfSalesHistory", header: "WEEKS", size: 120, cell: formattedCell},
    {accessorKey: "firstSalesDate", header: "FIRST WEEK", size: 150, cell: formattedCell},
    {accessorKey: "latestWeek", header: "LATEST WEEK", size: 150, cell: formattedCell},
    {accessorKey: "annualizedScv", header: "ANNUALIZED SCV", size: 180, cell: formattedCell},
    {accessorKey: "estimatedAcv", header: "CALCULATED ACV", size: 180, cell: formattedCell},
    {accessorKey: "scv", header: "ROLLING SCV", size: 160, cell: formattedCell},
];

const salesHistoryTrProps = (row) => ({
    className: classnames("rt-tr", row.index % 2 === 0 ? "-odd" : "-even", "linkage-sales-history-row",
        {winner: row.original.isWinner}),
    "data-testid": `linkage-sales-history-row-${row.original.id}`
});

const StoreLinkageSalesHistory = ({members, salesHistory, loading = false, error}) => {
    const rows = useMemo(() => members.map(({id, source, sourceStoreId, isWinner}) => ({
        id,
        source,
        sourceStoreId,
        isWinner,
        ...salesHistory.get(id),
    })), [members, salesHistory]);

    if (error) {
        return <div className={"store-linkage-empty"} data-testid={STORE_LINKAGE_SALES_HISTORY_ERROR_TEST_ID}>{error}</div>;
    }

    return <LoadingWrapper loading={loading} spinnerClassName={'spinner-container-medium'}>
        <div data-testid={STORE_LINKAGE_SALES_HISTORY_TABLE_TEST_ID}>
            <ReactTable
                className={"linkage-sales-history-table"}
                data={rows}
                columns={SALES_HISTORY_COLUMNS}
                showPagination={false}
                getRowId={(row) => row.id}
                getTrProps={salesHistoryTrProps}
            />
        </div>
    </LoadingWrapper>;
};

StoreLinkageSalesHistory.propTypes = {
    members: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        source: PropTypes.string,
        sourceStoreId: PropTypes.string,
        isWinner: PropTypes.bool,
    })).isRequired,
    salesHistory: PropTypes.instanceOf(Map).isRequired,
    loading: PropTypes.bool,
    error: PropTypes.string,
};

export default StoreLinkageSalesHistory;
